import React from "react";
import PolicyLayout from "./PolicyLayout";

function OrderCancellation() {
  return (
    <PolicyLayout
      title="Order cancellation policy"
      intro="A cancellation request is handled according to the order's payment and dispatch state when support receives it."
    >
      <section>
        <h2>How to request cancellation</h2>
        <p>Email the order number from the checkout email address and identify the complete order or individual line to stop. A message begins the request; cancellation takes effect only when support confirms that fulfilment has been stopped.</p>
      </section>

      <section>
        <h2>Before and after dispatch preparation</h2>
        <p>If verified payment exists and the goods can still be stopped, the approved amount is returned through the original payment route. Once packing, carrier handover or another irreversible dispatch step prevents a stop, the order follows the delivery and return procedures instead. Refusing delivery is not a substitute for cancellation instructions and can create avoidable return risk.</p>
      </section>

      <section>
        <h2>Hosted checkout states</h2>
        <p>Leaving or cancelling the hosted payment page does not require an order refund where no payment was completed. Likewise, the storefront's success return page is not proof that funds settled. We verify the payment-session record before confirming whether a cancellation involves a refund.</p>
      </section>

      <section>
        <h2>Seller-initiated cancellation</h2>
        <p>We may cancel before acceptance if payment cannot be verified, order information is invalid, supply cannot be completed, the transaction is fraudulent, or an alcohol order cannot lawfully be supplied to the destination or recipient. Captured funds for cancelled goods are returned through the original payment route. This does not restrict any mandatory remedy for wrongful non-supply.</p>
      </section>
    </PolicyLayout>
  );
}

export default OrderCancellation;
